module.exports = __webpack_public_path__ + "img/murano_side.d52ff2dc.png";